// export default class Approach {
//     constructor() {
//         this.$tiles = document.querySelectorAll('section.approach [data-flip-status]');
//         [...this.$tiles].forEach((tile) => {
//             tile.addEventListener('mouseover', (ev) => {
//                 if (tile.getAttribute('data-flip-status') === "front") {
//                     tile.setAttribute('data-flip-status', 'back');
//                 } else {
//                     tile.setAttribute('data-flip-status', 'front');
//                 }
//             });
//         });
//     }
// }
// new Approach();

if (is_touch_device()) {
  //for testing purposes only
  // if (!is_touch_device()) {
  document.querySelectorAll(".flip-card").forEach((card) => {
    card.classList.add("touch");
    card.querySelectorAll("p[data-function='toggler']").forEach((toggler) => {
      toggler.addEventListener("click", function () {
        card.classList.toggle("flipped");
      });
    });
  });
}

function is_touch_device() {
  if ("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }
}
